import styled from '@emotion/styled';
import { memo } from 'react';

interface Props {
  children?: any;
  className?: string;
}

const Component = memo((props: Props) => {
  return <Headline className={props.className}>{props.children}</Headline>;
});

const Headline = styled.span`
  background: linear-gradient(
    73.82deg,
    #11d79b -24.74%,
    #11bdd7 16.25%,
    #0054d1 79.08%,
    #8e00d1 113.33%
  );
  -webkit-background-clip: text;
  color: transparent;
`;

export default Component;
